"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _assets = _interopRequireDefault(require("@insided/deprecated-preact-components/assets"));

var _buttonControl = _interopRequireDefault(require("@insided/deprecated-preact-components/button-control"));

var _axios = _interopRequireDefault(require("axios"));

var _GroupSelector = _interopRequireDefault(require("../../../control/modules/Groups/GroupSelector"));

var _RadioInputGroup = _interopRequireDefault(require("@insided/shared/uikit/RadioInputGroup"));

var _Modal = require("@insided/shared/uikit/Modal");

var _InputGroup = _interopRequireDefault(require("@insided/shared/uikit/InputGroup"));

var _Textarea = _interopRequireDefault(require("../../ui-components/Textarea"));

var _common = require("@insided/shared/utils/common");

var _publish = _interopRequireDefault(require("../../../components/tracker/publish"));

var _Message = require("../../ui-components/Message");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var joinCommunityAndGroup = 'Join community and a group';
var joinCommunity = 'Join community';

var InviteContact = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(InviteContact, _Component);

  var _super = _createSuper(InviteContact);

  function InviteContact() {
    var _this;

    (0, _classCallCheck2.default)(this, InviteContact);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      isContactInviteModalOpen: false,
      inviteType: joinCommunity,
      inviteTypeChoices: [joinCommunity],
      customMessage: '',
      groupId: null,
      groups: [],
      selectGroupError: ''
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onInviteContact", function () {
      var performBulkAction = _this.props.performBulkAction;
      var _this$state = _this.state,
          inviteType = _this$state.inviteType,
          groupId = _this$state.groupId,
          customMessage = _this$state.customMessage;

      if (inviteType === joinCommunityAndGroup && !groupId) {
        _this.setState({
          selectGroupError: 'Please select a group.'
        });

        return;
      }

      var isGroupInvite = inviteType === joinCommunityAndGroup;
      var bulkAction = {
        successMessage: 'Invitations have been sent successfully',
        onClick: function () {
          var _onClick = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(selectedContacts) {
            var selectedContactsIds;
            return _regenerator.default.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    selectedContactsIds = selectedContacts.map(function (contact) {
                      return contact.id;
                    });

                    _axios.default.post('/contact/invite', {
                      customMessage: customMessage,
                      groupId: isGroupInvite ? groupId : null,
                      contacts: selectedContactsIds
                    }).then(function () {
                      return _publish.default.trackEvent('userevent', {
                        type: 'Contact Invited',
                        total_contacts_invited: selectedContactsIds.length,
                        invite_type: isGroupInvite ? 'join user group' : 'join community'
                      });
                    });

                  case 2:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee);
          }));

          function onClick(_x) {
            return _onClick.apply(this, arguments);
          }

          return onClick;
        }()
      };
      performBulkAction(bulkAction);

      _this.setState({
        isContactInviteModalOpen: false
      });
    });
    return _this;
  }

  (0, _createClass2.default)(InviteContact, [{
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
        var _this2 = this;

        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (_common.common.isModuleActive('group')) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt("return");

              case 2:
                _context2.next = 4;
                return _axios.default.get('/group/list').then(function (res) {
                  _this2.setState({
                    groups: res.data,
                    inviteTypeChoices: [joinCommunity, joinCommunityAndGroup]
                  });
                }).catch(function () {});

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var numberOfSelectedItems = this.props.numberOfSelectedItems;
      var _this$state2 = this.state,
          isContactInviteModalOpen = _this$state2.isContactInviteModalOpen,
          selectGroupError = _this$state2.selectGroupError,
          inviteTypeChoices = _this$state2.inviteTypeChoices,
          inviteType = _this$state2.inviteType,
          groups = _this$state2.groups,
          customMessage = _this$state2.customMessage;
      return (0, _preact.h)("div", null, (0, _preact.h)(_buttonControl.default, {
        title: (0, _preact.h)("div", null, (0, _preact.h)(_assets.default, {
          icon: "addUser"
        }), "Send invite"),
        size: "medium",
        newStyle: true,
        variant: "secondary",
        className: "qa-invite-contact",
        onClick: function onClick() {
          return _this3.setState({
            isContactInviteModalOpen: true
          });
        }
      }), isContactInviteModalOpen && (0, _preact.h)(_Modal.Modal, {
        isOpen: isContactInviteModalOpen,
        size: "medium"
      }, (0, _preact.h)(_Modal.ModalHeader, {
        title: "Send invite to ".concat(numberOfSelectedItems, " contact").concat(numberOfSelectedItems > 1 ? 's' : ''),
        onClose: function onClose() {
          return _this3.setState({
            isContactInviteModalOpen: false
          });
        }
      }), (0, _preact.h)(_Modal.ModalBody, null, (0, _preact.h)(_Message.Message, {
        variant: "info",
        text: "Please note that contacts who have been invited before will not receive an invitation email again."
      }), (0, _preact.h)("div", {
        className: "contact-invite-modal"
      }, (0, _preact.h)(_RadioInputGroup.default, {
        title: "Invite contacts to",
        options: inviteTypeChoices,
        onChange: function onChange(option) {
          return _this3.setState({
            inviteType: option,
            selectGroupError: ''
          });
        },
        value: inviteType,
        underneath: true
      }), groups.length > 0 && (0, _preact.h)("div", {
        className: "group-select-wrapper"
      }, (0, _preact.h)(_InputGroup.default, {
        customInput: (0, _preact.h)(_GroupSelector.default, {
          groups: groups,
          onGroupSelected: function onGroupSelected(groupId) {
            return _this3.setState({
              groupId: groupId,
              selectGroupError: ''
            });
          },
          disabled: inviteType === joinCommunity
        }),
        error: selectGroupError
      })), (0, _preact.h)("label", {
        className: "contact-invite-modal__textarea-label"
      }, "Invite message"), (0, _preact.h)("div", null, "It\u2019s more likely for people to accept an invite if there is a personalised message attached."), (0, _preact.h)(_Textarea.default, {
        adjustHeight: true,
        class: "contact-invite-modal__textarea",
        placeholder: "e.g. Nice to meet you at the event, let\u2019s stay in touch in the community.",
        newStyle: true,
        onContentChange: function onContentChange(value) {
          return _this3.setState({
            customMessage: value
          });
        },
        value: customMessage
      }))), (0, _preact.h)(_Modal.ModalFooter, null, (0, _preact.h)(_buttonControl.default, {
        title: "Send invite via email",
        newStyle: true,
        onClick: this.onInviteContact,
        size: "medium",
        variant: "brand"
      }))));
    }
  }]);
  return InviteContact;
}(_preact.Component);

var _default = InviteContact;
exports.default = _default;